import { marketingSolutionsConfigs } from './marketing-solutions';
import { financialSolutionsConfigs } from './financial-solutions';
import { hrSolutionsConfigs } from './hr-solutions';
import { operationsSolutionsConfigs } from './operations-solutions';
import { productivitySolutionsConfigs } from './productivity-solutions';
import { legalSolutionsConfigs } from './legal-solutions';
import { educationSolutionsConfigs } from './education-solutions';
import { serviceHospitalityConfigs } from './service-hospitality-solutions';
import { communicationConsultingSolutionsConfigs } from './communication-consulting-solutions';
import { coreApplicationsSolutionsConfigs } from './core-applications-solutions';
import { customSolutionsConfigs } from './custom-solutions';
import { marketingSalesSuiteFeatures } from './marketing-sales-suite';
import { facilitiesManagementSuiteConfig } from './facilities-management-suite-config';
import { digitalNewsroomPlatformConfig } from './digital-newsroom-platform-config';
import { completeHrManagementPlatformConfig } from './complete-hr-management-platform-config';
import { bpoQualityAssuranceSystemConfig } from './quality-assurance-system-config';
import { callRecordingSystemConfig } from './call-recording-system-config';
import { workforceManagementSystemConfig } from './workforce-management-system-config';
import { itServiceDeskPlatformConfig } from './it-service-desk-platform-config';
import { passengerTransportationManagementConfig } from './passenger-transportation-management-config';
import { timeAttendanceSystemConfig } from './time-attendance-system-config';
import { completePayrollSystemFeatures } from './complete-payroll-system';
import { mentalHealthSolutionsConfigs } from './mental-health-solutions';
import { expandedEducationSolutionsConfigs } from './expanded-education-solutions';
import { expandedFinancialSolutionsConfigs } from './expanded-financial-solutions';
import { completeFinancialSolutionsConfigs } from './complete-financial-solutions';
import { globalEmployerOfRecordFeatures } from './global-employer-of-record';
import { ProductConfigs } from './types';
import { coworkingManagementSuiteFeatures } from './coworking-management-suite';
import { venueManagementSystemFeatures } from './venue-management-system';
import { streamingPlatformFeatures } from './streaming-platform';
// Import new comprehensive category configurations
import { agricultureSolutionsConfigs } from './agriculture-solutions';
import { healthcareSolutionsConfigs } from './healthcare-solutions';
import { retailSolutionsConfigs } from './retail-solutions';
import { hospitalitySolutionsConfigs } from './hospitality-solutions';
import { realEstateSolutionsConfigs } from './real-estate-solutions';
import { technologySolutionsConfigs } from './technology-solutions';
import { entertainmentSolutionsConfigs } from './entertainment-solutions';
import { beautyFashionSolutionsConfigs } from './beauty-fashion-solutions';
import { healthBeautySolutionsConfigs } from './health-beauty-solutions';
import { communicationSolutionsConfigs } from './communication-solutions';
import { consultingSolutionsConfigs } from './consulting-solutions';
import { industrySolutionsConfigs } from './industry-solutions';
import { intelligenceSolutionsConfigs } from './intelligence-solutions';
import { intelligenceAnalyticsProducts } from './intelligence-analytics';
// Import new enhanced features for missing product categories
import { aiMachineLearningConfigs } from './ai-machine-learning-solutions';
import { developerToolsConfigs } from './developer-tools-solutions';
import { dataAnalyticsBIConfigs } from './data-analytics-bi-solutions';
import { customerSuccessCRMConfigs } from './customer-success-crm-solutions';
import { emergingTechnologiesConfigs } from './emerging-technologies-solutions';
import { customDevelopmentSolutionsConfigs } from './custom-development-solutions';
import { manufacturingSolutionsConfigs } from './manufacturing-solutions';
import { creativeSolutionsConfigs } from './creative-solutions';
import { recruitmentSolutionsConfigs } from './recruitment-solutions';
import { languageTestingSolutionsConfigs } from './language-testing-solutions';
import { oilGasSolutionsConfigs } from './oil-gas-solutions';
import { completeHealthBeautySolutionsConfigs } from './complete-health-beauty-solutions';
import { remainingHealthBeautySolutionsConfigs } from './remaining-health-beauty-solutions';
import { expandedHealthcareSolutionsConfigs } from './expanded-healthcare-solutions';
import { boulevardPremiumEnhancedConfigs } from './boulevard-premium-enhanced';
import { aiBeautyPlatformsConfigs } from './ai-beauty-platforms';
import { businessManagementBeautyConfigs } from './business-management-beauty';
import { finalMissingBeautySolutionsConfigs } from './final-missing-beauty-solutions';
import { crownpeakBeautyDxpConfig } from './crownpeak-beauty-dxp';
import { facilitiesSolutionsConfigs } from './facilities-solutions';
import { missingIntegrationBeautySolutionsConfigs } from './missing-integration-beauty-solutions';
import { additionalMissingBeautySolutionsConfigs } from './additional-missing-beauty-solutions';
import { industryVerticalsSolutionsConfigs } from './industry-verticals-solutions';
import { mobileDevelopmentSolutionsConfigs } from './mobile-development-solutions';
import { technologyIntegrationSolutionsConfigs } from './technology-integration-solutions';
import { bpoContactCentreSolutionsConfigs } from './bpo-contact-centre-solutions';
import { missingHrSolutionsConfigs } from './missing-hr-solutions';
// New comprehensive enhanced features
import { coreApplicationsEnhancedConfigs } from './core-applications-enhanced';
import { intelligenceAnalyticsEnhancedConfigs } from './intelligence-analytics-enhanced';
import { productivityEnhancedConfigs } from './productivity-enhanced';

// Combine all product configurations
export const allProductConfigs: ProductConfigs = {
  ...industrySolutionsConfigs,
  ...marketingSolutionsConfigs,
  ...financialSolutionsConfigs,
  ...hrSolutionsConfigs,
  ...missingHrSolutionsConfigs,
  ...operationsSolutionsConfigs,
  ...productivitySolutionsConfigs,
  ...legalSolutionsConfigs,
  ...educationSolutionsConfigs,
  ...serviceHospitalityConfigs,
  ...communicationConsultingSolutionsConfigs,
  ...intelligenceSolutionsConfigs,
  ...coreApplicationsSolutionsConfigs,
  ...customSolutionsConfigs,
  ...mentalHealthSolutionsConfigs,
  ...expandedEducationSolutionsConfigs,
  ...expandedFinancialSolutionsConfigs,
  ...completeFinancialSolutionsConfigs,
  ...completeHealthBeautySolutionsConfigs,
  ...remainingHealthBeautySolutionsConfigs,
  ...expandedHealthcareSolutionsConfigs,
  ...boulevardPremiumEnhancedConfigs,
  ...aiBeautyPlatformsConfigs,
  ...businessManagementBeautyConfigs,
  ...finalMissingBeautySolutionsConfigs,
  // New comprehensive category configurations
  ...agricultureSolutionsConfigs,
  ...healthcareSolutionsConfigs,
  ...retailSolutionsConfigs,
  ...hospitalitySolutionsConfigs,
  ...realEstateSolutionsConfigs,
  ...technologySolutionsConfigs,
  ...entertainmentSolutionsConfigs,
  ...beautyFashionSolutionsConfigs,
  ...healthBeautySolutionsConfigs,
  ...communicationSolutionsConfigs,
  ...consultingSolutionsConfigs,
  ...industrySolutionsConfigs,
  ...intelligenceSolutionsConfigs,
  ...intelligenceAnalyticsProducts,
  // New enhanced features for missing product categories
  ...aiMachineLearningConfigs,
  ...developerToolsConfigs,
  ...dataAnalyticsBIConfigs,
  ...customerSuccessCRMConfigs,
  ...emergingTechnologiesConfigs,
  ...customDevelopmentSolutionsConfigs,
  ...manufacturingSolutionsConfigs,
  ...creativeSolutionsConfigs,
  ...recruitmentSolutionsConfigs,
  ...languageTestingSolutionsConfigs,
  ...oilGasSolutionsConfigs,
  // Facilities Management Solutions
  ...facilitiesSolutionsConfigs,
  // Marketing & Sales Suite
  'marketing-sales-suite': marketingSalesSuiteFeatures,
  // Facilities Management Suite
  'facilities-management-suite': facilitiesManagementSuiteConfig,
  // Digital Newsroom Platform
  'digital-newsroom-platform': digitalNewsroomPlatformConfig,
  // Complete HR Management Platform
  'complete-hr-management-platform': completeHrManagementPlatformConfig,
  // Quality Assurance System
  'quality-assurance-system': bpoQualityAssuranceSystemConfig,
  // Call Recording System
  'call-recording-system': callRecordingSystemConfig,
  // Workforce Management System
  'workforce-management-system': workforceManagementSystemConfig,
  // IT Service Desk Platform
  'it-service-desk-platform': itServiceDeskPlatformConfig,
  // Passenger Transportation Management
  'passenger-transportation-management': passengerTransportationManagementConfig,
  // Time & Attendance System
  'time-attendance-system': timeAttendanceSystemConfig,
  // Complete Payroll System
  'complete-payroll-system': completePayrollSystemFeatures,
  // Global Employer of Record Platform
  'global-employer-of-record': globalEmployerOfRecordFeatures,
  // Coworking Management Suite
  'coworking-management-suite': coworkingManagementSuiteFeatures,
  // Entertainment & Media Products
  'venue-management-system': venueManagementSystemFeatures,
  'streaming-platform': streamingPlatformFeatures,
  // Beauty & Fashion Products
  'crownpeak-beauty-dxp': crownpeakBeautyDxpConfig,
  // Missing Integration & Beauty Solutions
  ...missingIntegrationBeautySolutionsConfigs,
  ...additionalMissingBeautySolutionsConfigs,
  // Industry Verticals Solutions
  ...industryVerticalsSolutionsConfigs,
  // Mobile Development Solutions
  ...mobileDevelopmentSolutionsConfigs,
  // Technology & Integration Solutions
  ...technologyIntegrationSolutionsConfigs,
  // BPO & Contact Centre Solutions
  ...bpoContactCentreSolutionsConfigs,
  // New comprehensive enhanced features for all categories
  ...coreApplicationsEnhancedConfigs,
  ...intelligenceAnalyticsEnhancedConfigs,
  ...productivityEnhancedConfigs,
};

// Helper function to get configuration for a specific product
export const getProductFeatureConfig = (productId: string) => {
  const aliasMap: Record<string, string> = {
    'website-webapp-suite': 'websites-web-apps',
    'streaming-media-platform': 'streaming-platform',
  };
  const resolvedId = aliasMap[productId] || productId;
  return allProductConfigs[resolvedId] || null;
};

// Export types for external use
export type { ProductFeatureConfig, FeatureCard } from './types';